<template>
  <section>
    <v-dialog v-model="dialog">
      <div class="dialog-container">
        <div class="header">
          <h3>ID {{rowInfo.id}}</h3>
          <span
            class="el-icon-close icon"
            @click="changeDialog"></span>
        </div>
        <div class="main">
          <div>
            <p>
              File Name: <a
                class="file-name"
                :href="rowInfo.file_url"
                @click="download"
              >{{rowInfo.file_client_name}}</a>
            </p>
          </div>
          <div class="flex">
            <p>Total: <span>{{rowInfo.total}}</span></p>
            <p>Successful: <span class="green">{{rowInfo.success_total}}</span></p>
            <p>Failed: <span class="red">{{rowInfo.failed_total}}</span></p>
            <p>Skiped: <span>{{rowInfo.skip_total}}</span></p>
          </div>
          <div>
            <p>Failed Tracking Number:</p>
            <div class="num-list">
              <template v-if="rowInfo.failed_mess">
                <p
                  v-for="(val,index) in rowInfo.failed_mess"
                  :key="index">{{val}}</p>
              </template>
              <p v-else>(none)</p>
            </div>
          </div>
        </div>
        <div class="btn">
          <v-button
            @click="changeDialog">Close</v-button>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import {downloadFileName} from '@/utils/download'
export default {
  name: 'ResultDialog',
  props:{
    rowInfo:{
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    changeDialog(){
      this.dialog = !this.dialog
    },

    download(e){
      e.preventDefault()
      let url = this.rowInfo.file_url
      let filename = this.rowInfo.file_client_name
      downloadFileName(url,filename)
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container{
  padding: 15px;
  .header{
    height: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    h3{
      padding-bottom: 0;
    }
    .icon{
      font-size: 20px;
      cursor: pointer;
    }
  }
  .main{
    .file-name{
      color: #409EFF;
      display: inline-block;
      padding: 0 5px;
      text-decoration: none;
    }
    .flex{
      margin: 10px 0;
      p{
        flex: 1;
        .green{
          color: #28A745;
        }
        .red{
          color: #CB2431;
        }
      }
    }
    .num-list{
      margin-top: 10px;
      border: 1px solid #dad7e2;
      padding: 0 10px;
      border-radius: 5px;
      p{
        padding: 5px 0;
      }
    }
    p{
      span{
        padding: 0 5px;
      }
    }
  }
  .btn{
    margin-top: 20px;
    text-align: right;
  }
}
</style>
